import { z as zod } from 'zod';
import { LinkSchema } from "@/app/features/shared/__to_be_integrated/types/forms/LinkSchema";
import { MediaRefSchema } from "@/app/features/shared/__to_be_integrated/types/forms/MediaRefSchema";
import { PhoneSchema } from "@/app/features/shared/__to_be_integrated/types/forms/PhoneSchema";

// TODO: find a better place
export const SimpleIntroSchema = zod.object({
    id: zod.string(),
    title: zod.string().min(1, { message: 'Titel fehlt' }),
    subtitle: zod.string().nullish(),
    image: MediaRefSchema,
})

export const SiteCooperationsSchema = zod.object({
    intro: zod.object({
        id: zod.string(),
        title: zod.string().min(1, { message: 'Titel fehlt' }),
        subtitle: zod.string().nullish(),
        image: MediaRefSchema,
    })
});

export const PartnerSchema = zod.object({
    order: zod.number().int(),
    name: zod.string().min(1, 'Der Name darf nicht leer sein.'),
    description: zod.string().min(1, 'Beschreibung darf nicht leer sein.'),
    email: zod.string().email().nullish(),
    image: MediaRefSchema.nullish(),
    phone: PhoneSchema.nullish(),
    website: LinkSchema.nullish()
});
